(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hpq-product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    function haptic() {
      if (navigator.vibrate) navigator.vibrate(10);
    }

    function setMode(qty, mode, count) {
      var card = qty.closest('[data-hpq-card]');
      qty.className = 'hpq-qty hpq-qty--' + mode;
      if (count === 1) qty.classList.add('hpq-qty--count-1');
      if (count > 0) {
        qty.querySelector('[data-hpq-qty-count]').textContent = count;
        qty.querySelector('[data-hpq-qty-badge-count]').textContent = count;
        card.classList.add('hpq-card--in-cart');
      } else {
        card.classList.remove('hpq-card--in-cart');
      }
    }

    function collapseQty(qty) {
      if (!qty || !qty.classList.contains('hpq-qty--active')) return;
      setMode(qty, 'collapsed', parseInt(qty.querySelector('[data-hpq-qty-count]').textContent, 10));
    }

    function collapseActiveQtys(exceptQty) {
      document.querySelectorAll('[data-hpq-qty].hpq-qty--active').forEach(function(qty) {
        if (exceptQty && qty === exceptQty) return;
        collapseQty(qty);
      });
    }

    function syncCardsFromCart(cart) {
      if (!cart || !cart.items) return;
      var qtyMap = {};
      for (var i = 0; i < cart.items.length; i++) {
        qtyMap[String(cart.items[i].variant_id)] = cart.items[i].quantity;
      }
      document.querySelectorAll('[data-hpq-card]').forEach(function(card) {
        var variantId = card.dataset.variantId;
        var qty = card.querySelector('[data-hpq-qty]');
        if (!qty) return;
        var cartQty = qtyMap[variantId] || 0;
        if (cartQty > 0) {
          setMode(qty, qty.classList.contains('hpq-qty--active') ? 'active' : 'collapsed', cartQty);
        } else {
          setMode(qty, 'idle', 0);
        }
      });
    }

    // Hydrate from local cart (instant) or Shopify (fallback)
    function hydrateCards() {
      if (window.hpqCart && window.hpqCart.isLoaded()) {
        syncCardsFromCart(window.hpqCart.getCart());
      } else {
        // Wait for local cart to hydrate
        document.addEventListener('cart:updated', function onFirst(e) {
          if (e.detail && e.detail.cart) {
            syncCardsFromCart(e.detail.cart);
            document.removeEventListener('cart:updated', onFirst);
          }
        });
        // Trigger hydration if local cart exists but hasn't loaded
        if (window.hpqCart && !window.hpqCart.isLoaded()) {
          window.hpqCart.hydrate();
        }
      }
    }
    hydrateCards();

    // Bidirectional sync: when cart changes elsewhere
    document.addEventListener('cart:updated', function(e) {
      if (e.detail && e.detail.source === 'hpq-card') return;
      var cart = (e.detail && e.detail.cart);
      if (cart && cart.items) syncCardsFromCart(cart);
    });

    document.addEventListener('click', function(e) {
      var clickedQty = e.target.closest('[data-hpq-qty]');
      if (!clickedQty) {
        var hasActiveQty = document.querySelector('[data-hpq-qty].hpq-qty--active');
        if (hasActiveQty) {
          collapseActiveQtys();
          if (e.target.closest('a, button')) {
            e.preventDefault();
            e.stopPropagation();
          }
          return;
        }
      }

      // + Add
      var addBtn = e.target.closest('[data-hpq-qty-add]');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        var qty = addBtn.closest('[data-hpq-qty]');
        var card = qty.closest('[data-hpq-card]');
        var variantId = card.dataset.variantId;
        var price = parseInt(card.dataset.price || '0', 10);
        var title = card.dataset.title || '';
        var imgEl = card.querySelector('img');
        var linkEl = card.querySelector('a[href*="/products/"]');
        var meta = {
          image: imgEl ? imgEl.src : '',
          url: linkEl ? linkEl.getAttribute('href') : ''
        };

        // addQty (not setQty) — rapid clicks increment correctly
        if (window.hpqCart) {
          collapseActiveQtys(qty);
          window.hpqCart.addQty(variantId, 1, price, title, meta);
          setMode(qty, 'active', window.hpqCart.getQty(variantId));
        }
        haptic();
        return;
      }

      // + (more)
      var plusBtn = e.target.closest('[data-hpq-qty-plus]');
      if (plusBtn) {
        e.preventDefault();
        e.stopPropagation();
        var qty = plusBtn.closest('[data-hpq-qty]');
        var card = qty.closest('[data-hpq-card]');
        var variantId = card.dataset.variantId;
        var price = parseInt(card.dataset.price || '0', 10);
        var title = card.dataset.title || '';

        // Read from hpqCart (single source of truth, not DOM textContent)
        if (window.hpqCart) {
          window.hpqCart.addQty(variantId, 1, price, title);
          setMode(qty, 'active', window.hpqCart.getQty(variantId));
        }
        haptic();
        return;
      }

      // - (minus/trash)
      var minusBtn = e.target.closest('[data-hpq-qty-minus]');
      if (minusBtn) {
        e.preventDefault();
        e.stopPropagation();
        var qty = minusBtn.closest('[data-hpq-qty]');
        var card = qty.closest('[data-hpq-card]');
        var variantId = card.dataset.variantId;

        // Read from hpqCart (single source of truth, not DOM textContent)
        if (window.hpqCart) {
          window.hpqCart.addQty(variantId, -1);
          var newQty = window.hpqCart.getQty(variantId);
          haptic();
          if (newQty <= 0) {
            setMode(qty, 'idle', 0);
          } else {
            setMode(qty, 'active', newQty);
          }
        }
        return;
      }

      // Badge click — expand
      var badgeBtn = e.target.closest('[data-hpq-qty-badge]');
      if (badgeBtn) {
        e.preventDefault();
        e.stopPropagation();
        var qty = badgeBtn.closest('[data-hpq-qty]');
        var count = parseInt(qty.querySelector('[data-hpq-qty-count]').textContent, 10);
        collapseActiveQtys(qty);
        setMode(qty, 'active', count);
        return;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
